<template>
  <div class="box">
    <div class="top" @click="toBack()">
      <img src="../../assets/images/wap/goback.png" alt="">
    </div>
    <span :class="(showStatus && userInfo.utype == 0) ? 'top-titles' :'top-title'">红狮直播间</span>
    <div class="checkin">
      <img @click.stop="handleRoomList" src="../../assets/images/wap/video.png" alt="">
      <div v-if="showStatus && userInfo.utype == 0">
        <!-- 用户未点击签到且时间已到 -->
        <div :class="ckplayerObject.live ? 'checkin-box' : 'checkin-box box1'" v-if="!signStatus && isSign">
          <!-- 有直播 -->
          <div class="plays" @click="toSignIn" v-if="ckplayerObject.live">

            <span>积分+{{ signInfo.integral }}</span>

          </div>
          <!-- 无直播 -->
          <!-- <div class="plays1" v-else>

            <span>积分+{{ signInfo.integral }}</span>

          </div> -->
        </div>

        <!-- 接口返回签到状态 -->
        <div class="checkin-box1 checkin-box boxs2" v-if="signStatus">
          <img src="../../assets/images/wap/sign.png" alt="">
          <div class="play">

            <span>已签到</span>

          </div>
        </div>
        <div class="checkin-box1 checkin-box boxs1" v-if="!signStatus && !isSign && ckplayerObject.live">
          <img src="../../assets/images/wap/icons.png" alt="">

          <div class="play">

            <span>签到</span>
            <span>{{ min + ':' }}{{ second }}</span>
          </div>
        </div>
      </div>
      <!-- <img @click.stop="sendOpenLive800" src="../../assets/images/wap/kefu.png" alt=""> -->
    </div>
  </div>
</template>

<script>
import config from '../../config/index'
import { getSignIn, saveSignIn } from '../../api/home'
import { isReactNative, isAndroidNative, isIOSNative } from "@/utils/tools";

export default {
  name: 'wapTab',
  props: {
    playTime: {
      type: String,
      default: '00:00'
    }
  },
  data() {
    return {
      signInfo: {},//用户签到情况
      hour: '',
      min: '00',
      second: '00',
      isSign: false,//是否签到
      showSign: false,//签到积分
      showStatus: true,
      signStatus: false,
    }
  },
  created() {
    this.getSignIns()
  },
  computed: {
    ckplayerObject() {
      return this.$store.state.home.ckplayerObject
    },
    userInfo() {
      return this.$store.state.login.userInfo
    },
    roomInfo() {
      return this.$store.state.home.roomInfo
    },
  },
  methods: {
    toBack() {
      if(isAndroidNative('finish')) {
        window.android.finish();
        return
      }
      if(isIOSNative()) {
        window.webkit.messageHandlers.finish.postMessage('1');
        return
      }
      if(isReactNative()) {
        const message = JSON.stringify({ method: 'finish' });
        window.ReactNativeWebView.postMessage(message);
        return
      }
      window.location.href = window.location.origin
    },
    // 获取用户登录信息
    getSignIns() {
      // 如果是未登录或者模拟账号不显示签到功能
      if (
        !this.userInfo.id ||
        this.$store.state.login.userInfo.nick.indexOf("游客") !== -1
      ) {
        this.showStatus = false
      }
      getSignIn({
        platid: 1,
        userId: this.userInfo.id,
        broomId: this.roomInfo.id,

      }).then(res => {
        console.log('登录信息-----------', res)

        if (res.Status === 0) {
          this.signInfo = res.data
          this.signStatus = res.data.isSign
          if (this.signInfo.signtime && this.showStatus) {
            this.countTime()

          }
        }
      })
    },
    // 用户签到
    submit() {
      saveSignIn({
        platid: 1,
        userId: this.userInfo.id,
        broomId: this.roomInfo.id,

      }).then(res => {
        console.log(res)
        if (res.Status === 0) {
          this.$message({
            message: res.message,
            type: 'success',
          });
          this.getSignIns()
        }
      })
    },
    // 登录用户点击签到
    toSignIn() {
      this.showSign = false
      this.submit()
    },
    countTime() {
      // 获取当前时间
      let now = new Date();

      //  let endDate = new Date(now.getTime() + 1 * 60 * 1000); // this.curStartTime需要倒计时的日期
      let endDate = new Date(now.getTime() + this.signInfo.signtime * 60 * 1000); // this.curStartTime需要倒计时的日期
      let count = Math.floor((endDate - now) / 1000)
      let timer = setInterval(() => {
        if (count >= 0) {
          let m = Math.floor((count / 60));
          this.min = m < 10 ? '0' + m : m;
          // 秒
          let s = Math.floor(count % 60);
          this.second = s < 10 ? '0' + s : s;
          count--
        } else {
          clearInterval(timer)
          this.isSign = true
          this.showSign = !this.showSign

        }
      }, 1000);
    },

    // 房间切换按钮
    async handleRoomList() {
      // await this.getRoomList()
      this.roomInfo.id ? this.$store.commit('home/set_roomtid', this.roomInfo.tId) : ''
      this.$store.commit('home/set_showroomlist', true)
      this.$store.commit('home/set_showVideo', false)
    },
    // 获取房间列表
    async getRoomList() {
      const option = {
        platid: config.platid,
        page: 0,
        size: 10
      }
      await this.$store.dispatch('home/getRoomList', option)
    },
    // 点击客服，传递给父元素
    sendOpenLive800() {
      this.$emit('send');
    }
  },


}
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  height: 45px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 10px 0 20px;

  .top {
    width: 90px;
    margin-top: 8px;

    img {
      width: 8px;
    }
  }

  .top-titles {
    font-weight: 600;
    text-align: center;
    margin-left: -5%;
  }
    .top-title {
      font-weight: 600;
      text-align: center;
      margin-left: -18%;
    }

  span {
    width: 90px;
    text-align: center;
    font-size: 15px;
  }

  .checkin {
    display: flex;
    align-items: center;

    img {
      width: 20px;
      margin: 0 8px;
    }

    .checkin-box {
      display: flex;
      align-items: center;
      // width: 64px;
      height: 30px;
      padding: 4px;
      box-sizing: border-box;
      border-radius: 40px;
      background: linear-gradient(286.17deg, #FF002B 0%, #FF8686 100%);
      font-size: 10px;
      line-height: 14px;
      color: #fff;
      cursor: pointer;

      img {
        margin: 0;
      }

      .play {
        display: flex;
        flex-direction: column;

        span {
          width: 40px;
          font-size: 10px;
        }

      }

      .plays {
        display: flex;
        flex-direction: column;
        padding: 8px 14px;

        span {
          width: 40px;
          font-size: 10px;
        }
      }

      .plays1 {
        display: flex;
        flex-direction: column;
        padding: 8px 20px;
        border-radius: 40px;

        background: linear-gradient(286.17deg, #FF002B 0%, #FF8686 100%);

        span {
          width: 40px;
          font-size: 10px;
        }
      }

    }

    .box1 {
      background: none;
    }

    .checkin-box1 {

      border: 1px solid #EE2547;

      background: #FFECEC;
      color: #EE2547;
      font-weight: 600;
    }

    .boxs1 {
      background: linear-gradient(286.17deg, #FF002B 0%, #FF8686 100%);
      border: none;
      color: #fff;
    }
  }
}
</style>